module.exports = __webpack_public_path__ + "static/made_in_USA-c7c89d05354a715755fde7ef0316ce50.png";